export function setupVhFallback() {
  if (window.CSS && CSS.supports && CSS.supports("height", "100dvh"))
    return () => {};
  const setVh = () => {
    document.documentElement.style.setProperty(
      "--vh",
      `${window.innerHeight * 0.01}px`
    );
  };
  setVh();
  window.addEventListener("resize", setVh);
  return () => window.removeEventListener("resize", setVh);
}
export default setupVhFallback;
